module.exports = __webpack_public_path__ + "img/mouseArrow.4b98b98b.svg";